<div class="floor-plan-popup">
  <button class="dialog-close-button" [mat-dialog-close]>
    <span class="material-icons"> close </span>
  </button>
  <h2 [innerHTML]="data.title"></h2>
  <img [src]="data.imageURL" alt="floor plan" />
</div>
